<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout v-if="modifyId" row wrap>
            <!-- Summary info -->
            <v-flex lg6 pa-0 pl-3 pt-3>
                <v-btn
                    :color="internalfinance.Status | display_color(itemStatus)"
                    width="160px"
                    height="36px"
                    small
                    dark
                    depressed
                    outlined
                  >{{ internalfinance.Status | display_value(itemStatus) }}</v-btn>
            </v-flex>
            <!-- Action buttons -->
            <v-flex lg6 pa-0 pr-3 pt-6>
                <v-layout row wrap justify-end>
                    <v-btn style="margin-right: 10px;" v-if="canDisburse" @click="saveData(statusEnum.giai_ngan)" color="#a77800" dark>
                        Giải ngân
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="canConfirm" @click="saveData(statusEnum.da_duyet)" color="#646262" dark>
                        Duyệt phiếu
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="canFinish" @click="saveData(statusEnum.hoan_thanh)" color="#646262" dark>
                        Hoàn thành
                    </v-btn>
                    <v-btn style="margin-right: 10px;" v-if="canCancel" @click="saveData(statusEnum.huy)" dark>Hủy</v-btn>
                    <v-btn style="margin-right: 10px;" v-if="internalfinance.Status == statusEnum.cho_duyet || adminRole" @click="createItem()" color="#a77800" dark>Save</v-btn>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex lg6 md6 sm12>
                <v-widget title="Thông tin thu/chi">
                    <div slot="widget-content" class="customer-info-box">
                        <v-card-text>
                            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                                <v-flex lg6 md6 sm12 pl-6>
                                    <v-select :disabled="internalfinance.Status != statusEnum.cho_duyet && !adminRole" :items="itemTypes" v-model="internalfinance.Type" label="Loại phiếu" item-text="name" item-value="value"></v-select>
                                </v-flex>
                                <v-flex lg6 md6 sm12 pl-6>
                                    <h-currency-input :disabled="internalfinance.Status != statusEnum.cho_duyet && !adminRole" v-model="internalfinance.Amount" :decimal="0" label="Số tiền (đ)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg12 md12 sm12>
                                    <v-textarea :disabled="internalfinance.Status != statusEnum.cho_duyet && !adminRole" v-model="internalfinance.Content" label="Nội dung" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>            
                        </v-card-text>
                    </div>
                </v-widget>
            </v-flex>
            <v-flex lg6 md6 sm12>
                <v-widget title="Chat box">
                    <div slot="widget-content">
                        <message-box :orderId="modifyId" :orderType="7" :isInternal="true" :isPrivate="true"></message-box>
                    </div>
                </v-widget>
            </v-flex>
        </v-layout>
        
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import configs from "@/configs";
import { sendErrorNotice } from "@/commons/utils";
import VWidget from "@/components/VWidget";
import MessageBox from "@/components/chat/MessageBox";

export default {
    components: {
        VWidget,
        MessageBox
    },
    data() {
        return {
            menuDate: false,
            itemTypes: configs.INTERNAL_FINANCE_TYPES,
            itemStatus: configs.INTERNAL_FINANCE_STATUS,
            statusEnum: configs.INTERNAL_FINANCE_STATUS_ENUM,
            typeEnum: configs.INTERNAL_FINANCE_TYPE_ENUM,
        };
    },
    computed: {
        ...mapState({
            loading: state => state.internalfinance.loading,
            internalfinance: state => state.internalfinance.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        },
        purchaseRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        },
        customerServiceRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        },
        storeVNRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        canCancel() {
            if (this.modifyId != 'tao-moi' && this.internalfinance && (this.adminRole || this.paymentRole)) {
                return true;
            }
            return false;
        },
        canFinish() {
            const statusEnum = configs.INTERNAL_FINANCE_STATUS_ENUM;
            const typeEnum = configs.INTERNAL_FINANCE_TYPE_ENUM;
            if (this.internalfinance && (this.adminRole || this.paymentRole)) {
                if((this.internalfinance.Status == statusEnum.da_duyet && this.internalfinance.Type != typeEnum.ung) || (this.internalfinance.Status == statusEnum.giai_ngan && this.internalfinance.Type == typeEnum.ung)) {
                    return true;
                }
            }
            return false;
        },
        canConfirm() {
            const statusEnum = configs.INTERNAL_FINANCE_STATUS_ENUM;
            if (this.internalfinance && this.adminRole) {
                if(this.internalfinance.Status == statusEnum.cho_duyet) {
                    return true;
                }
            }
            return false;
        },
        canDisburse() {
            const statusEnum = configs.INTERNAL_FINANCE_STATUS_ENUM;
            const typeEnum = configs.INTERNAL_FINANCE_TYPE_ENUM;
            if (this.internalfinance && this.internalfinance.Type == typeEnum.ung && (this.adminRole || this.paymentRole)) {
                if(this.internalfinance.Status == statusEnum.da_duyet) {
                    return true;
                }
            }
            return false;
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        },
        internalfinance() {
            if(this.internalfinance && this.internalfinance.ID > 0 && this.internalfinance.ReportDate > 0) {
                this.orderDate = moment.utc(this.internalfinance.ReportDate).toISOString().substr(0, 10)
            } 
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("internalfinance/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("internalfinance/setDetail", { data: {
                        ID: 0,
                        Status: 2
                    }
                })
            }
        },
        saveData(status) {
            this.$store.dispatch("internalfinance/setDetail", {
                data: {
                    Status: status
                },
                id: this.internalfinance.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "InternalFinanceList");
        },
        createItem() {
            if (!this.internalfinance.Type) {
                sendErrorNotice("Chưa chọn loại phiếu!");
                return;
            }
            if (!this.internalfinance.Amount) {
                sendErrorNotice("Chưa điền số tiền cho phiếu!");
                return;
            }
            if(!this.internalfinance.ID) {
                this.internalfinance.Status = this.internalfinance.Type == this.typeEnum.thu ? this.statusEnum.da_duyet : this.statusEnum.cho_duyet;
            }
            this.$store.dispatch("internalfinance/setDetail", {
                data: {
                    ...this.internalfinance
                },
                id: this.internalfinance.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "InternalFinanceList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>